export default "__VITE_ASSET__26442434__"